module.exports = __webpack_public_path__ + "img/user_avatar.87b02a18.png";